<p-avatarGroup styleClass="mb-3">
    <p-avatar image="assets/showcase/images/demo/avatar/amyelsner.png" size="large" shape="circle"></p-avatar>
    <p-avatar image="assets/showcase/images/demo/avatar/asiyajavayant.png" size="large" shape="circle"></p-avatar>
    <p-avatar image="assets/showcase/images/demo/avatar/onyamalimba.png" size="large" shape="circle"></p-avatar>
    <p-avatar image="assets/showcase/images/demo/avatar/ionibowcher.png" size="large" shape="circle"></p-avatar>
    <p-avatar image="assets/showcase/images/demo/avatar/xuxuefeng.png" size="large"shape="circle"></p-avatar>
    <p-avatar label="+2" shape="circle" size="large" [style]="{'background-color':'#9c27b0', 'color': '#ffffff'}"></p-avatar>
</p-avatarGroup>
